import * as React from "react";
import PageMenuItem from "../../../../../Layout/PageMenu/PageMenuItem";
import { LtlPipelineViewModel } from "../../../../ViewModel/LtlPipelineViewModel";

type Props = {
  onClick: () => void;
  ltlPipeline: LtlPipelineViewModel | undefined;
  disabled: boolean;
};

export const ClearRoutingButton = ({ onClick, ltlPipeline, disabled }: Props) => {
  const isButtonDisabled = (): boolean => {
    return !(
      ltlPipeline !== undefined &&
      ltlPipeline.routing !== undefined &&
      ltlPipeline.routing.length > 0
    );
  };

  return (
    <PageMenuItem
      align="right"
      color="primary"
      type="button"
      onClick={() => onClick()}
      disabled={isButtonDisabled() || disabled}
    >
      Clear Routing
    </PageMenuItem>
  );
};
